import { IMember } from "@wingspanhq/users/dist/lib/interfaces";
import { ComplianceEntity } from "@wingspanhq/wingspan-api-sdk";

export const selectorAccountType = (
  monitoredEntity?: ComplianceEntity,
  member?: IMember
) => {
  if (monitoredEntity?.type) {
    return monitoredEntity.type;
  }

  if (member?.profile.company?.taxId) {
    return "Business";
  }

  return "Individual";
};
